import React, { useReducer } from "react";
import "./ContextMenu.css";


const ContextMenu = ({ position, onOptionSelected }) => {
  const handleOptionSelected = option => () => onOptionSelected(option);
 
         

  return (
    <div
      className="menu"
      style={{
        position: "absolute",
        left: position.x,
        top: position.y
      }}
    >
      <ul>
      
        <li id="star" onClick={handleOptionSelected("star")}> star</li>
        <li id="fiber" onClick={handleOptionSelected("fiber")}> fiber</li>
        <li onClick={handleOptionSelected("rounded")}> Rounded</li>
        <li onClick={handleOptionSelected("square")}> Square</li>
        <li onClick={handleOptionSelected("text")}> Text</li>
        <li onClick={handleOptionSelected("image")}>Image</li>
       
        
      </ul>
      
        
    </div>
  );
};

export default ContextMenu;
